import { css } from "@emotion/css";

export const profileFooterStyle = css({
  position: "fixed",
  bottom: 0,
  left: 0,
  boxShadow: "0px 2px 16px 0px #0B0C0C1A",
  zIndex: 30,
  padding: "12px 16px"
});

export const borderStyle = css({
  "& > :not(:last-child)": {
    marginBottom: "0px !important",
    borderBottom: "1px solid #BBC0C1",
    wordBreak: "break-word",
  },
});

export const maskLoaderStyle = css({
  position: "fixed",
  top: 0,
  left: 0,
  bottom: 0,
  right: 0,
  width: "100%",
  height:"100vh",
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  zIndex:"55",
});

export const buttonStyle = css({
  backgroundColor: "white",
  ":hover": {
    boxShadow: "none",
    backgroundColor: "white"
  }
});

export const layoutDescriptionTextStyle = css({
  color: "#AED2CE !important",
  fontWeight: "700 !important",
});
